import 'babel-polyfill';
import './bugsnag';

// General import
import Lodash from 'lodash';
import Vue from 'vue';
import LineClamp from 'vue-line-clamp';
import Vuelidate from 'vuelidate';
import Axios from 'axios';
import VueSelect from 'vue-select';
import VueAxios from 'vue-axios';
import VueCookie from 'vue-cookie';
import Notifications from 'vue-notification';
import Slick from 'vue-slick';
import $ from 'jquery';
import VTooltip from 'v-tooltip';

Vue.use(Lodash);
Vue.use(LineClamp);
Vue.use(Notifications);
Vue.use(VueAxios, Axios);
Vue.use(VueCookie);
Vue.use(Vuelidate);
Vue.use(Slick);
Vue.use(VTooltip);

const moment = require('moment');
require('moment/locale/nl');
Vue.use(require('vue-moment'), {
    moment
});

Vue.filter('currency', value => {
    return parseFloat(value).toFixed(2);
});

Vue.filter('limit', value => {
    if (value.length > 27) {
        return value.slice(0, 27) + '...';
    }

    return value;
});

// Directives
import dataHref from './directives/dataHref';

Vue.directive('data-href', dataHref);

// Import components
import Alerts from '../components/Alerts';
import AdditionalCost from '../components/AdditionalCost';
import BelastingUploaden from '../components/BelastingUploaden';
import BeterMelden from '../components/BeterMelden';
import CookieBar from '../components/CookieBar';
import EndSubscription from '../components/EndSubscription';
import Faq from '../components/Faq';
import FaqForm from '../components/FaqForm';
import MijnBetalingen from '../components/MijnBetalingen';
import MijnBetalingenChart from '../components/MijnBetalingenChart';
import NieuweLeden from '../components/NieuweLeden';
import PaymentArrears from '../components/PaymentArrears';
import Payouts from '../components/Payouts';
import PreviousBatches from '../components/PreviousBatches';
import ResellerBlock from '../components/ResellerBlock';
import UitkeringAanpassen from '../components/UitkeringAanpassen'
import Spinner from 'vue-spinner-component/src/Spinner';
import SicknessHistory from '../components/SicknessHistory';
import SickMembers from '../components/SickMembers';
import ZiekMelden from '../components/ZiekMelden';
import ZiekMeldenPage from '../components/ZiekMeldenPage';

Vue.component('v-select', VueSelect);

// Transitions
import SlideToggle from './transitions/SlideToggle'

Vue.component('transition-slide-toggle', SlideToggle);

import {email, minLength, required} from 'vuelidate/lib/validators';
import mustBeTrue from './validators/mustBeTrue';
import passwordComplexity from './validators/passwordComplexity';

const emailUnique = (email) => Axios.post('/api/check-email', {email}).then(r => true).catch(e => false);

new Vue({
    el: '#vue-container',
    components: {
        AdditionalCost,
        Alerts,
        BelastingUploaden,
        BeterMelden,
        CookieBar,
        EndSubscription,
        Faq,
        FaqForm,
        MijnBetalingen,
        MijnBetalingenChart,
        NieuweLeden,
        PreviousBatches,
        PaymentArrears,
        Slick,
        Spinner,
        Payouts,
        ResellerBlock,
        UitkeringAanpassen,
        ZiekMelden,
        ZiekMeldenPage,
        SicknessHistory,
        SickMembers,
    },
    data() {
        return {
            donatieniveau: 1000,
            menuActive: false,
            slickOptions: {
                slidesToShow: 1,
                mobileFirst: true,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: 'unslick',
                    }
                ]
            },
            registration: {
                step: 1,
                tooltip: 'In het kader van de AVG (Algemene Verordening Gegevensbescherming) moet Socialtens je informeren dat zij je persoonsgegevens verwerkt. Gezien het doel van Socialtens, namelijk als intermediair op treden tussen deelnemers om elkaar te voorzien in een inkomensvoorziening tijdens arbeidsongeschiktheid, zullen eveneens medische en financiële gegevens verwerkt worden teneinde te kunnen vaststellen of je arbeidsongeschikt bent voor de uitoefening van je beroep of bedrijf, voor welk donatieniveau je in aanmerking komt en overige gegevens welke zijn opgenomen in het reglement. Socialtens verwerkt de medische gegevens niet zelf (wel de financiële gegevens) maar deze gegevens zullen verwerkt worden door de gecontracteerde bedrijfsgezondheidsdienst en de door hen ingeschakelde bedrijfs- of arboartsen. Namens deze organisatie wordt toestemming verzocht om deze gegevens te verwerken, en uitsluitend wanneer je je arbeidsongeschikt hebt gemeld binnen de beveiligde omgeving van Socialtens.nl. Tevens verwijst Socialtens naar haar <a href="/privacyverklaring">privacyverklaring.</a>',
            },
            registerForm: {
                checkbox: '',
                checkbox2: '',
                first_name: '',
                last_name: '',
                email: '',
                day: '',
                month: '',
                year: '',
                bedrijfsnaam: '',
                kvk_nummer: '',
                beroepsgroep: 'Advies en consultancy',
                password: '',
            }
        };
    },
    validations() {
        return {
            registerForm: {
                // step1:
                checkbox: {
                    mustBeTrue,
                },
                checkbox2: {
                    mustBeTrue,
                },
                // step2:
                first_name: {
                    required,
                },
                last_name: {
                    required,
                },
                email: {
                    required,
                    email,
                    emailUnique,
                },
                day: {
                    required,
                },
                month: {
                    required,
                },
                year: {
                    required,
                },
                bedrijfsnaam: {
                    required,
                },
                kvk_nummer: {
                    required,
                },
                beroepsgroep: {
                    required,
                },
                password: {
                    required,
                    minLength: minLength(8),
                    passwordComplexity,
                },
            }
        }
    },
    computed: {
        payment() {
            // 1,2% betekent 1 van 83 deelnemers is ziek
            // we gaan ervanuit dat de gemiddelde bedrag 2000 is
            let total = 82 * 2000; // 82, want 1 is ziek
            let part = (this.donatieniveau / total) * 2000;

            return  Math.round(part);
        },
    },
    methods: {
        menu() {
            this.menuActive = !this.menuActive;

            let body = document.querySelector('body');

            if (this.menuActive) {
                body.classList.add('menu-opened');
            } else {
                body.classList.remove('menu-opened');
            }
        },
        registerStep(requestedStep) {
            this.$v.registerForm.checkbox.$touch();
            this.$v.registerForm.checkbox2.$touch();

            if (requestedStep === 2 && (this.$v.registerForm.checkbox.$invalid || this.$v.registerForm.checkbox2.$invalid)) {
                return
            }

            if (requestedStep === 2) {
                window.dataLayer.push({
                    event: 'registrationStepOne',
                    donationAmount: this.donatieniveau,
                });
            }

            this.registration.step = requestedStep;
        },
        registerSubmit() {
            this.$v.registerForm.$touch();

            if(!this.$v.registerForm.$invalid){
                this.$refs.registerForm.submit();

                window.dataLayer.push({
                    event: 'registrationComplete',
                    donationAmount: this.donatieniveau,
                    profession: this.$v.registerForm.beroepsgroep,
                });
            }
        },
    },
    created() {
        this.axios.defaults.headers.common = {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': document.querySelector('meta[name="_token"]').getAttribute('content'),
        };
    },
    mounted() {
        // All inputs except datepickers
        $(':input[name]:not(.js-pickadate)').focus(function () {
            $(this).closest('.form-group').addClass('active');
        }).blur(function () {
            let $input = $(this);

            if ($.trim($input.val()) === '') {
                $input.closest('.form-group').removeClass('active');
            } else {
                $input.closest('.form-group').addClass('active');
            }
        }).trigger('blur');

        function SmoothMenuScroll() {
            var anchor = $('.scrollToLink');
            if (anchor.length) {
                anchor.children('a').bind('click', function(event) {
                    if ($(window).scrollTop() > 10) {
                        var headerH = '80';
                    } else {
                        var headerH = '120';
                    }
                    var target = $(this);
                    $('html, body').stop().animate({
                        scrollTop: $(target.attr('href')).offset().top - headerH + 'px'
                    }, 1200, 'easeInOutExpo');
                    anchor.removeClass('current');
                    target.parent().addClass('current');
                    event.preventDefault();
                });
            }
        }
        SmoothMenuScroll();

        function OnePageMenuScroll() {
            var windscroll = $(window).scrollTop();
            if (windscroll >= 100) {
                var menuAnchor = $('.one-page-scroll-menu .scrollToLink').children('a');
                menuAnchor.each(function() {
                    // grabing section id dynamically
                    var sections = $(this).attr('href');
                    $(sections).each(function() {
                        // checking is scroll bar are in section
                        if ($(this).offset().top <= windscroll + 100) {
                            // grabing the dynamic id of section
                            var Sectionid = $(sections).attr('id');
                            // removing current class from others
                            $('.one-page-scroll-menu').find('li').removeClass('current');
                            // adding current class to related navigation
                            $('.one-page-scroll-menu').find('a[href*=\\#' + Sectionid + ']').parent().addClass('current');
                        }
                    });
                });
            } else {
                $('.one-page-scroll-menu li.current').removeClass('current');
                $('.one-page-scroll-menu li:first').addClass('current');
            }
        }


        $(window).on('scroll', function() {
            if ($('.scroll-to-top').length) {
                var strickyScrollPos = 100;
                if ($(window).scrollTop() > strickyScrollPos) {
                    $('.scroll-to-top').fadeIn(500);
                } else if ($(this).scrollTop() <= strickyScrollPos) {
                    $('.scroll-to-top').fadeOut(500);
                }
            }
            if ($('.stricky').length) {
                var headerScrollPos = 100;
                var stricky = $('.stricky');
                if ($(window).scrollTop() > headerScrollPos) {
                    stricky.removeClass('slideIn animated');
                    stricky.addClass('stricky-fixed slideInDown animated');
                } else if ($(this).scrollTop() <= headerScrollPos) {
                    stricky.removeClass('stricky-fixed slideInDown animated');
                    stricky.addClass('slideIn animated');
                }
            }
            OnePageMenuScroll();
        });
    },
});


Vue.config.productionTip = false;

/* eslint-disable no-console */

console.log(' ');
console.log('%cSpreek jij onze taal?', 'font-weight: bold; color: black;');
console.log('%cGa naar https://bttr.nl/vacatures', 'font-weight: bold; color: black;');
console.log(' ');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js